// COURSE IDs
export const CWIV1GGUID = 'cl8bpkss900003b68lww2m8az'
export const CWIV2GGUID = 'clpx286t000013b6buj1q8rgq'
